<template>
    <b-container class="section">
        <b-row class="text-center align-items-center justify-content-center">
            <slot/>
        </b-row>
        <hr v-if=lineAfter />
    </b-container>
</template>

<script>
    export default {
        name: 'Section',
        props: {
            title: String,
            text: String,
            lineAfter: Boolean
        }
    }
</script>

<style>
    .section{
        padding-top: 56px;
        margin-top: -56px;
    }

    .section:before {
        height: 75px;
        content: "";
        display:block;
    }
</style>